import {
  favoritesPath,
  learnerProfilesPath,
  transactionsPathV2,
  transcriptsPath
} from "@outschool/routes";
import { Loading } from "@outschool/ui-legacy-component-library";
import { lazyWithRetry } from "@outschool/ui-utils";
import React, { Suspense } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import ParentDashboardLayout from "./layouts/ParentDashboardLayout";

const ClassesPage = lazyWithRetry(() => import("./pages/ClassesPage"));
const FavoritesPage = lazyWithRetry(() => import("./pages/FavoritesPage"));
const TranscriptsPage = lazyWithRetry(() => import("./pages/TranscriptsPage"));
const TransactionsPage = lazyWithRetry(
  () => import("./pages/TransactionsPage")
);
const LearnerProfilesPage = lazyWithRetry(
  () => import("./pages/LearnerProfilesPage")
);

export default function ParentDashboardV2() {
  const match = useRouteMatch();

  return (
    <ParentDashboardLayout>
      <Suspense fallback={<Loading />}>
        <Switch>
          <Route exact path={favoritesPath()} component={FavoritesPage} />
          <Route exact path={transcriptsPath()} component={TranscriptsPage} />
          <Route
            exact
            path={transactionsPathV2()}
            component={TransactionsPage}
          />
          <Route
            exact
            path={learnerProfilesPath()}
            component={LearnerProfilesPage}
          />
          <Route exact path={match.path} component={ClassesPage} />
        </Switch>
      </Suspense>
    </ParentDashboardLayout>
  );
}
